import React from 'react';

import './FooterAction.scss';

import { Container, ButtonToolbar, ButtonGroup } from 'react-bootstrap';

const FooterActions = ({ButtonGroupRight = () => (<></>), ButtonGroupLeft = () => (<></>)}) => (
  <footer className="extra-rounded-top fixed-bottom">
    <Container fluid className="max-width">
      <ButtonToolbar 
        xs={2} 
        className="justify-content-between my-2"
        aria-label="Botões de Ações">
        <ButtonGroup>
          <ButtonGroupLeft />
        </ButtonGroup>
        <ButtonGroup>
          <ButtonGroupRight />
        </ButtonGroup>
      </ButtonToolbar>
    </Container>
  </footer>
)

export default FooterActions;